// Templates
import pricingTableTariffsTemplate from "./templates/typeahead/pricing-table-tariffs.html";
import popoverDesignFontsTemplate from "./templates/popover-design-fonts.html";
import popoverDesignImagesTemplate from "./templates/popover-design-images.html";
import appTemplate from "./templates/router/app.html";
import notFoundTemplate from "./templates/router/not-found.html";
import popoverProfileTemplate from "./templates/popover-profile/popover-profile.html";
import popoverQuoteActivityTemplate from "./templates/popover-quote-activity/popover-quote-activity.html";
import popoverQuoteVersionsTemplate from "./templates/popover-quote-versions/popover-quote-versions.html";

// Overrides
import bootstrapMatchMultipleTemplate from "./overrides/bootstrap/match-multiple.tpl.html";
import bootstrapMatchTemplate from "./overrides/bootstrap/match.tpl.html";
import uiSelectMatchMultipleTemplate from "./overrides/angular-ui-select/bootstrap/match-multiple.tpl.html";
import uibDatepickerDayTemplate from "./overrides/uib/template/datepicker/day.html";
import uibDatepickerMonthTemplate from "./overrides/uib/template/datepicker/month.html";
import uibDatepickerYearTemplate from "./overrides/uib/template/datepicker/year.html";
import uibDatepickerPopupTemplate from "./overrides/uib/template/datepickerPopup/popup.html";

/* @ngInject */
function angularTemplateCache($templateCache) {
  // Templates
  $templateCache.put("templates/typeahead/pricing-table-tariffs.html", pricingTableTariffsTemplate);
  $templateCache.put("templates/popover-design-fonts.html", popoverDesignFontsTemplate);
  $templateCache.put("templates/popover-design-images.html", popoverDesignImagesTemplate);
  $templateCache.put("templates/router/app.html", appTemplate);
  $templateCache.put("templates/router/not-found.html", notFoundTemplate);
  $templateCache.put("templates/popover-profile/popover-profile.html", popoverProfileTemplate);
  $templateCache.put("templates/popover-quote-activity/popover-quote-activity.html", popoverQuoteActivityTemplate);
  $templateCache.put("templates/popover-quote-versions/popover-quote-versions.html", popoverQuoteVersionsTemplate);

  // Overrides
  $templateCache.put("bootstrap/match-multiple.tpl.html", bootstrapMatchMultipleTemplate);
  $templateCache.put("bootstrap/match.tpl.html", bootstrapMatchTemplate);
  $templateCache.put("angular-ui-select/bootstrap/match-multiple.tpl.html", uiSelectMatchMultipleTemplate);
  $templateCache.put("uib/template/datepicker/day.html", uibDatepickerDayTemplate);
  $templateCache.put("uib/template/datepicker/month.html", uibDatepickerMonthTemplate);
  $templateCache.put("uib/template/datepicker/year.html", uibDatepickerYearTemplate);
  $templateCache.put("uib/template/datepickerPopup/popup.html", uibDatepickerPopupTemplate);
}

export default angularTemplateCache;
